// Split out of `../runner.ts`, which is now the barrel over this directory.

import { fnv1a32 } from '../../value-objects/fnv1a32';

// Deterministic display-name word lists. A box's name is `<adjective> <noun>`
// picked by hashing its runner id — memorable, stable, and collision-light
// across a personal fleet (32 × 48 = 1536 combos). Title-cased so it reads as a
// proper name in a PR/issue comment ("Swift Nova opened a PR").
const NAME_ADJECTIVES = [
  'Swift',
  'Lunar',
  'Cobalt',
  'Amber',
  'Quiet',
  'Brave',
  'Nimble',
  'Stellar',
  'Crimson',
  'Azure',
  'Golden',
  'Silent',
  'Rapid',
  'Lucid',
  'Vivid',
  'Noble',
  'Sunny',
  'Arctic',
  'Ember',
  'Jade',
  'Onyx',
  'Pearl',
  'Rustic',
  'Cosmic',
  'Feral',
  'Gentle',
  'Hardy',
  'Ionic',
  'Keen',
  'Mellow',
  'Prime',
  'Zesty',
] as const;
const NAME_NOUNS = [
  'Nova',
  'Atlas',
  'Orion',
  'Vega',
  'Lyra',
  'Titan',
  'Juno',
  'Astra',
  'Comet',
  'Nebula',
  'Quasar',
  'Pulsar',
  'Zephyr',
  'Halcyon',
  'Phoenix',
  'Griffin',
  'Hydra',
  'Kraken',
  'Falcon',
  'Raven',
  'Otter',
  'Lynx',
  'Bison',
  'Heron',
  'Cobra',
  'Puma',
  'Ibis',
  'Wren',
  'Fox',
  'Elk',
  'Owl',
  'Hawk',
  'Crane',
  'Moth',
  'Newt',
  'Seal',
  'Toad',
  'Vole',
  'Wolf',
  'Bear',
  'Lark',
  'Mole',
  'Gull',
  'Finch',
  'Stork',
  'Swan',
  'Sable',
  'Marten',
] as const;

/**
 * A friendly, DETERMINISTIC box name derived from its runner id — arc 101 slice
 * 04. Every ai-dev gets a name so dashboards, PR/issue comments, and
 * notifications say "Swift Nova fixed CI on repo X" instead of a runner UUID.
 * Same id ⇒ same name, always (no state, no clock, no RNG), so it can be
 * regenerated anywhere the stored `display_name` is absent (legacy rows) and
 * still agree with what was stamped at enrollment. A user-set name overrides it
 * (the stored column wins); this is the fallback + the enroll-time default.
 */
export function generateDisplayName(runnerId: string): string {
  const h = fnv1a32(runnerId);
  const adjective = NAME_ADJECTIVES[h % NAME_ADJECTIVES.length];
  const noun = NAME_NOUNS[Math.floor(h / NAME_ADJECTIVES.length) % NAME_NOUNS.length];
  return `${adjective} ${noun}`;
}
